import { Menu as MenuMui } from '@mui/base/Menu';
import { MenuButton } from '@mui/base/MenuButton';
import { Dropdown as DropdownMui } from '@mui/base/Dropdown';
import { useAnalytics } from 'edrolo/analytics';
import { ProfileMenuItem as IProfileMenuItem } from '../../../NavBar';
import { Icon, enums } from 'edrolo-ui';
import { ProfileMenuItem } from './ProfileMenuItem';
import styles from './styles.scss';

interface MenuProps {
  buttonTitle: string;
  menuItems: IProfileMenuItem[];
}

export const ProfileMenu = ({
  buttonTitle,
  menuItems,
}: MenuProps): JSX.Element => {
  const { track } = useAnalytics({});

  return (
    <DropdownMui
      onOpenChange={(_, isOpen) => {
        if (isOpen) {
          track('profile menu clicked', { origin: 'profile menu' });
        }
      }}
    >
      <MenuButton className={styles.menuButton} data-mp-mask>
        {buttonTitle}
        <Icon name={enums.Icons.CHEVRON_DOWN} />
      </MenuButton>
      <MenuMui
        slotProps={{
          root: {
            placement: 'bottom-start',
            className: styles.root,
          },
          listbox: {
            className: styles.listbox,
          },
        }}
      >
        <ul>
          {menuItems.map((menuItem, index) => (
            <ProfileMenuItem key={index} menuItem={menuItem} />
          ))}
        </ul>
      </MenuMui>
    </DropdownMui>
  );
};
